/*
 *
 * TermsPages
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import { fetchTermsRequest } from './actions';
import {
  Terms,
  TermsWrap,
} from './styledComponents';
import H1 from 'components/H1';

class TermsPage extends React.PureComponent{
  componentDidMount(){
    this.props.fetchTerms();
  }
  render(){
      return(
        this.props.camber_terms.terms
        ?
        <Terms>
          <H1>Movebooth Terms of Service and Privacy Policy</H1>
          <TermsWrap dangerouslySetInnerHTML={{ __html: this.props.camber_terms.terms.camber_terms}}/>
        </Terms>
        :
        <div />
      );
    }
}

const mapStateToProps = (state) => ({
  camber_terms: state.terms,
});

const mapDispatchToProps = (dispatch) => ({
  fetchTerms: () => dispatch(fetchTermsRequest()),
});
export default connect(mapStateToProps,mapDispatchToProps)(TermsPage);



// WEBPACK FOOTER //
// ./src/containers/TermsPage/index.js